import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardActions from "react-md/lib/Cards/CardActions";
import FontIcon from "react-md/lib/FontIcons";
import Button from "react-md/lib/Buttons/Button";

import { closeDialog } from "../../actions/dialogActions";

function disableScroll() {
    // console.log('%cdialogWrap active => hidden','color:red');
    document.body.style.overflow = "hidden";
}

function enableScroll() {
    document.body.style.overflow = "scroll";
    // console.log('%cdialogWrap active => scroll','color:green');
}

const DialogWrap = ({
  name,
  active,
  title,
  closeDialog,
  handleSubmit,
  onClose,
  submitLabel,
  children,
  className,
  stornoLabel,
  stornoOnClick
}) => {

  // console.log('dialogWrap refresh', name, active);

  // FIX: after closing dialog body had overflow:hidden
  // FIXME: will this work with multiple dialogs ...?
  if (name === active) {
        disableScroll();
  } else {
        enableScroll();
  }

  return (
    <div className={classNames({ hidden: name !== active })}>
      <div className="dialog-background" />
      <Card raise className={`dialog ${className}`}>
        <FontIcon
          className="dialog-close"
          onClick={() => {
              enableScroll();
            if (onClose) onClose();
            closeDialog();
          }}
        >
          close
        </FontIcon>
        <CardText className="dialog-title">{title}</CardText>
        <CardText className="dialog-content">{children}</CardText>
        <CardActions className="dialog-menu">
            <CardText>
                  <Button
                    flat
                    secondary
                    label={stornoLabel || "Storno"}
                    onClick={() => {
                      if (stornoOnClick) {
                        stornoOnClick();
                      } else {
                        enableScroll();
                        if (onClose) onClose();
                        closeDialog();
                      }
                    }}
                    className="margin-right touchButton-5"
                  />
                  <div className="touchButtons-spaceBetween" />
                  <Button
                    flat
                    primary
                    label={submitLabel}
                    onClick={() => {
                      enableScroll();
                      handleSubmit();
                    }}
                    className="margin-right  touchButton-6"
                  />
            </CardText>
        </CardActions>
      </Card>
    </div>
  );
};

DialogWrap.propTypes = {
  name: PropTypes.string,
  active: PropTypes.string,
  title: PropTypes.string,
  closeDialog: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default connect(({ dialog: { name } }) => ({ active: name }), {
  closeDialog
})(DialogWrap);



// WEBPACK FOOTER //
// ./src/components/dialogs/DialogWrap.js